var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('DashboardWidgetWiedervorlagen')],1),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('DashboardWidgetTermine')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }